import IconTriangleArrowTop from '@creditflowresearch/uilib/Icon/IconTriangleArrowTop';
import Tooltip from '@creditflowresearch/uilib/Tooltip';

import styles from './upsizedCell.module.scss';

interface IUpsizedCellProps {
  upsized?: boolean,
}

const UpsizedCell = ({ upsized = true }: IUpsizedCellProps) => (
  <div className={ styles.upsizedCol } data-test="dealRowUpsized">
    {
      upsized
      && (
        <Tooltip content="Deal Upsized" wrpClassName={ styles.upsizedTooltip }>
          <IconTriangleArrowTop size={ 10 } className={ styles.icon } />
        </Tooltip>
      )
    }
  </div>
);

export default UpsizedCell;
